import { render, staticRenderFns } from "./CameraPageShootCardDiagonal.vue?vue&type=template&id=3d88ea29&scoped=true&"
import script from "./CameraPageShootCardDiagonal.vue?vue&type=script&lang=ts&"
export * from "./CameraPageShootCardDiagonal.vue?vue&type=script&lang=ts&"
import style0 from "./CameraPageShootCardDiagonal.vue?vue&type=style&index=0&id=3d88ea29&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d88ea29",
  null
  
)

export default component.exports